import React, { useEffect, useRef, useState, useCallback } from 'react';
import './AdCarousel.css';

import adHair from '../../assets/ad-slide-hair.png';
import adMakeup from '../../assets/ad-slide-makeup.png';
import adWellness from '../../assets/ad-slide-wellness.png';

const AD_SLIDES = [
  {
    id: 'hair',
    image: adHair,
    tint: 'rgba(139, 94, 60, 0.72)',
    kicker: 'Soins capillaires',
    title: 'PREMIUM',
    subtitle: 'Coiffure, tresses, tissage — nos meilleurs salons.',
    cta: 'Découvrir',
  },
  {
    id: 'makeup',
    image: adMakeup,
    tint: 'rgba(186, 74, 119, 0.72)',
    kicker: 'Maquillage',
    title: 'TREND',
    subtitle: 'Make-up mariée, soirée, tous les styles du moment.',
    cta: 'Voir la collection',
  },
  {
    id: 'wellness',
    image: adWellness,
    tint: 'rgba(58, 124, 165, 0.72)',
    kicker: 'Routine',
    title: 'BIEN-ÊTRE',
    subtitle: 'Spa, massage, soins visage — offrez-vous une pause.',
    cta: 'Explorer',
  },
];

const AUTO_INTERVAL_MS = 5000;

function AdCarousel({ onSlideClick }) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const startX = useRef(null);

  const goTo = useCallback((i) => {
    const n = AD_SLIDES.length;
    setIndex(((i % n) + n) % n);
  }, []);

  useEffect(() => {
    if (paused) return undefined;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % AD_SLIDES.length);
    }, AUTO_INTERVAL_MS);
    return () => clearInterval(id);
  }, [paused]);

  const handleTouchStart = (e) => {
    startX.current = e.touches?.[0]?.clientX ?? null;
  };

  const handleTouchEnd = (e) => {
    if (startX.current == null) return;
    const endX = e.changedTouches?.[0]?.clientX ?? startX.current;
    const delta = endX - startX.current;
    if (Math.abs(delta) > 50) {
      goTo(index + (delta < 0 ? 1 : -1));
    }
    startX.current = null;
  };

  return (
    <div
      className="ad-carousel"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div
        className="ad-track"
        style={{ transform: `translate3d(-${index * 100}%, 0, 0)` }}
      >
        {AD_SLIDES.map((slide) => (
          <button
            key={slide.id}
            type="button"
            className="ad-slide"
            onClick={() => onSlideClick?.(slide)}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <span
              className="ad-slide-tint"
              style={{ background: `linear-gradient(105deg, transparent 8%, ${slide.tint} 55%, rgba(12,8,6,0.88) 100%)` }}
            />
            <span className="ad-slide-content">
              <span className="ad-slide-kicker">{slide.kicker}</span>
              <span className="ad-slide-title">{slide.title}</span>
              <span className="ad-slide-sub">{slide.subtitle}</span>
              <span className="ad-slide-cta">{slide.cta} →</span>
            </span>
          </button>
        ))}
      </div>

      <button
        type="button"
        className="ad-arrow ad-arrow-left"
        onClick={(e) => {
          e.stopPropagation();
          goTo(index - 1);
        }}
        aria-label="Slide précédente"
      >
        ‹
      </button>
      <button
        type="button"
        className="ad-arrow ad-arrow-right"
        onClick={(e) => {
          e.stopPropagation();
          goTo(index + 1);
        }}
        aria-label="Slide suivante"
      >
        ›
      </button>

      <div className="ad-dots" role="tablist" aria-label="Pagination">
        {AD_SLIDES.map((s, i) => (
          <button
            key={s.id}
            type="button"
            role="tab"
            aria-selected={i === index}
            aria-label={`Slide ${i + 1}`}
            className={`ad-dot${i === index ? ' active' : ''}`}
            onClick={() => goTo(i)}
          />
        ))}
      </div>
    </div>
  );
}

export default AdCarousel;
